// extracted by mini-css-extract-plugin
export var colorSquare = "_ok-0";
export var danger = "_ok-5";
export var lightPink = "_ok-8";
export var neutralBlue = "_ok-7";
export var neutralYellow = "_ok-6";
export var normal = "_ok-1";
export var primary = "_ok-2";
export var primaryLight = "_ok-3";
export var solidBlack = "_ok-g";
export var solidGreen = "_ok-b";
export var solidLightBlue = "_ok-d";
export var solidNavy = "_ok-c";
export var solidOrange = "_ok-f";
export var solidPink = "_ok-e";
export var solidRed = "_ok-9";
export var solidYellow = "_ok-a";
export var success = "_ok-4";